// Go through a meta object and return the value of the key
export function getMeta(name, defaultValue, meta) {
  const metaItem = meta ? meta.find((m) => m.name === name) : null;
  return metaItem ? metaItem.value : defaultValue;
}
